import React from 'react'
import './Technologies.css';
import reactLogo from '../pictures/lib/react.svg';
import nextLogo from '../pictures/lib/next.png';
import bootstrapLogo from '../pictures/lib/bootstrap.png';
import nodeLogo from '../pictures/lib/nodejs.png';
import mongodbLogo from '../pictures/lib/mongodb.png';
import gsapLogo from '../pictures/lib/gsap.jpeg';
import tailwind from '../pictures/lib/tailwind.png';

const Technologies = () => {
  return (
    <div className='technologies'>
      <h1 style={{"fontWeight" : "700"}}>Skills & Technologies</h1>
      <ul>
        <li><div className='tech-container'><img src={reactLogo} alt="React" width={48} /><span>React</span></div></li>
        <li><div className='tech-container'><img src={nextLogo} alt="Next.js" width={48} /><span>Next.js</span></div></li>
        <li><div className='tech-container'><img src={nodeLogo} alt="Node.js" width={48} /><span>Node.js</span></div></li>
        <li><div className='tech-container'><img src={mongodbLogo} alt="MongoDB" width={48} /><span>MongoDB</span></div></li>
        <li><div className='tech-container'><img src={tailwind} alt="Tailwind" width={48} /><span>Tailwind</span></div></li>
        <li><div className='tech-container'><img src={bootstrapLogo} alt="Bootstrap" width={48} /><span>Bootstrap</span></div></li>
        <li><div className='tech-container'><img src={gsapLogo} alt="GSAP" width={48} /><span>GSAP</span></div></li>
      </ul>
    </div>
  )
}

export default Technologies
